import { AppThunkAction } from '../reducers';
import { ErrorType } from '../../models/HttpError';
import { ContractConceptCategory, NewContractConceptCategory } from '../../models/Entities/Contracts/ContractConceptCategory';
import * as Services from '../../services/ContractConceptCategory.Services';
import { ContractConceptCategoryAction } from '../actions/ContractConceptCategory.Actions';

export const actionCreators = {
    /** `force` relee aunque ya esté cargado: el drawer lo usa al abrir. */
    GetAllContractConceptCategories: (force: boolean = false): AppThunkAction<ContractConceptCategoryAction> => async (dispatch, getState) => {
        const state = getState().ContractConceptCategories;
        if (state?.isLoadingAll) return;
        if (!force && state?.successLoadingAll) return;

        dispatch({ type: 'CONTRACT_CONCEPT_CATEGORY_GET_ALL_REQUEST_ACTION' });
        Services.GetAllContractConceptCategories()
            .then((categories: ContractConceptCategory[]) => dispatch({ type: 'CONTRACT_CONCEPT_CATEGORY_GET_ALL_RECEIVE_ACTION', categories }))
            .catch((error: ErrorType) => dispatch({ type: 'CONTRACT_CONCEPT_CATEGORY_GET_ALL_FAIL_ACTION', error }));
    },

    AddContractConceptCategory: (category: NewContractConceptCategory): AppThunkAction<ContractConceptCategoryAction> => async (dispatch) => {
        dispatch({ type: 'CONTRACT_CONCEPT_CATEGORY_ADD_REQUEST_ACTION', category });
        Services.CreateContractConceptCategory(category)
            .then((created: ContractConceptCategory) => dispatch({ type: 'CONTRACT_CONCEPT_CATEGORY_ADD_RECEIVE_ACTION', category: created }))
            .catch((error: ErrorType) => dispatch({ type: 'CONTRACT_CONCEPT_CATEGORY_ADD_FAIL_ACTION', error }));
    },

    UpdateContractConceptCategory: (category: ContractConceptCategory): AppThunkAction<ContractConceptCategoryAction> => async (dispatch) => {
        dispatch({ type: 'CONTRACT_CONCEPT_CATEGORY_UPDATE_REQUEST_ACTION', category });
        Services.UpdateContractConceptCategory(category)
            // El PUT puede responder sin cuerpo: lo que se mandó es lo que vale.
            .then((updated: ContractConceptCategory) => dispatch({ type: 'CONTRACT_CONCEPT_CATEGORY_UPDATE_RECEIVE_ACTION', category: updated ?? category }))
            .catch((error: ErrorType) => dispatch({ type: 'CONTRACT_CONCEPT_CATEGORY_UPDATE_FAIL_ACTION', error }));
    },

    DeleteContractConceptCategory: (categoryId: number): AppThunkAction<ContractConceptCategoryAction> => async (dispatch) => {
        dispatch({ type: 'CONTRACT_CONCEPT_CATEGORY_DELETE_REQUEST_ACTION', categoryId });
        Services.DeleteContractConceptCategory(categoryId)
            .then(() => dispatch({ type: 'CONTRACT_CONCEPT_CATEGORY_DELETE_RECEIVE_ACTION', categoryId }))
            .catch((error: ErrorType) => dispatch({ type: 'CONTRACT_CONCEPT_CATEGORY_DELETE_FAIL_ACTION', categoryId, error }));
    },

    ResetContractConceptCategoryFlags: (): AppThunkAction<ContractConceptCategoryAction> => async (dispatch) => {
        dispatch({ type: 'CONTRACT_CONCEPT_CATEGORY_RESET_FLAGS_ACTION' });
    }
};
